import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Observable, switchMap, of } from 'rxjs';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { PartyRoleTypes } from '../../party/model/party-role-types.model';

@Injectable({
    providedIn: 'root'
})
export class PartyRoleTypeDataService extends DefaultDataService<PartyRoleTypes> {
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, public urlProvider: UrlProviderService) {
        super('PartyRoleTypes', http, httpUrlGenerator);
    }

    override getAll(): Observable<PartyRoleTypes[]> {
        const url = this.urlProvider.getUrl(EndPoints.partyRoles_IndexPartyRoleTypes, undefined, undefined);
        return this.http
            .get(
                url,
                (Headers = {
                    ...this.urlProvider.baseGetOptions()
                })
            )
            .pipe(
                switchMap((res: any) => {
                    return of(<PartyRoleTypes[]>res.body['partyRoleTypes']);
                })
            );
    }
}
